<template>

<div class="checklist" :class="{'is-flag': flag}">

	<button class="checklist-item" v-for="option in input.options" :key="option.id" v-on:click="onOptionClick(option.value)" :class="{'is-active': isActive(option.value)}">

		<div class="checklist-item-check"><i class="fa-solid fa-check" v-if="isActive(option.value)"></i></div>

		<span>{{ option.text }}</span>

	</button>

</div>

</template>

<script>

export default {

	props: ['input', 'flag'],

	computed: {

		value: function() {

			return this.$store.getters['session/values'][this.input.variable] || []

		}

	},

	methods: {

		onOptionClick: function(value) {

			this.$store.dispatch('set', {
				input: this.input.id,
				variable: this.input.variable,
				value: value
			})

		},

		isActive: function(value) {

			return this.$_.contains(this.value, value)

		}

	}

}

</script>

<style scoped>

.checklist {
	display: flex;
	flex-direction: column;
	width: 100%;
}

.checklist-item {
	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 12px 16px;
	background-color: transparent;
	border: 2px solid #e0e0e0;
	border-radius: 12px;
	margin-bottom: 8px;
	cursor: pointer;
	text-align: left;
	font-size: 16px;
	font-weight: 400;
	color: #343434;
	transition: all 300ms ease-in-out;
}

.is-mobile .checklist-item {
	font-size: 14px;
	padding: 10px 12px;
	border-radius: 8px;
}

.checklist-item:hover {
	border-color: var(--primary-color);
}

.checklist-item:hover .checklist-item-check {
	color: #ccc;
}

.checklist-item.is-active {
	border-color: #343434;
	background-color: #343434;
	color: #fff;
}

.checklist-item-check {
	width: 24px;
	height: 24px;
	flex-shrink: 0;
	margin-right: 12px;
	border-radius: 4px;
	border: 2px solid #ccc;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 12px;
	color: transparent;
	transition: all 300ms ease-in-out;
}

.checklist-item.is-active .checklist-item-check {
	border-color: #fff;
	background-color: #343434;
	color: #fff;
}

.is-flag .checklist-item {
	border-color: #ee7173;
}

</style>
